import { render, staticRenderFns } from "./CustomBuyPrint.vue?vue&type=template&id=3284ddfb&scoped=true&"
import script from "./CustomBuyPrint.vue?vue&type=script&lang=js&"
export * from "./CustomBuyPrint.vue?vue&type=script&lang=js&"
import style0 from "./CustomBuyPrint.vue?vue&type=style&index=0&id=3284ddfb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3284ddfb",
  null
  
)

export default component.exports